import {
    ALL_DEVICES_MODAL_PROPS_CHANGED,
    INCREASE_CREDIT_MODAL_PROPS_CHANGED,
    INCREASE_CREDIT_MODAL_PROPS_CLEARED,
    INCREASE_REPORT_MODAL_PROPS_CHANGED,
    MESSAGE_MODAL_PROPS_CHANGED,
} from './types';

export const changeIncreaseReportModalProps = props => ({
    type: INCREASE_REPORT_MODAL_PROPS_CHANGED,
    payload: props,
});

export const changeIncreaseCreditModalProps = props => ({
    type: INCREASE_CREDIT_MODAL_PROPS_CHANGED,
    payload: props,
});

export const clearIncreaseCreditModalProps = () => ({
    type: INCREASE_CREDIT_MODAL_PROPS_CLEARED,
});

export const changeAllDevicesModalProps = props => ({
    type: ALL_DEVICES_MODAL_PROPS_CHANGED,
    payload: props,
});

export const changeMessageModalProps = props => ({
    type: MESSAGE_MODAL_PROPS_CHANGED,
    payload: props,
});
